//ws
export const wsUrl = 'wss://ws.mwrex.com/ws'
